// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"ff7cc5f8","258":"d2b2c4e8","307":"1534e0f0","404":"1a70a2db","815":"82080957","830":"4d49206c","948":"2564606f"}[chunkId] + ".chunk.js";
};